export const LIST_SERVICE_DOMAIN_REQUEST = 'LIST_SERVICE_DOMAIN_REQUEST'
export const LIST_SERVICE_DOMAIN_SUCCESS = 'LIST_SERVICE_DOMAIN_SUCCESS'
export const LIST_SERVICE_DOMAIN_FAIL = 'LIST_SERVICE_DOMAIN_FAIL'

export const CREATE_SERVICE_DOMAIN_REQUEST = 'CREATE_SERVICE_DOMAIN_REQUEST'
export const CREATE_SERVICE_DOMAIN_SUCCESS = 'CREATE_SERVICE_DOMAIN_SUCCESS'
export const CREATE_SERVICE_DOMAIN_FAIL = 'CREATE_SERVICE_DOMAIN_FAIL'

export const CREATE_SERVICE_DOMAIN_SERVICE_REQUEST = 'CREATE_SERVICE_DOMAIN_SERVICE_REQUEST'
export const CREATE_SERVICE_DOMAIN_SERVICE_SUCCESS = 'CREATE_SERVICE_DOMAIN_SERVICE_SUCCESS'
export const CREATE_SERVICE_DOMAIN_SERVICE_FAIL = 'CREATE_SERVICE_DOMAIN_SERVICE_FAIL'

export const DETAIL_SERVICE_DOMAIN_SERVICE_REQUEST = 'DETAIL_SERVICE_DOMAIN_SERVICE_REQUEST'
export const DETAIL_SERVICE_DOMAIN_SERVICE_SUCCESS = 'DETAIL_SERVICE_DOMAIN_SERVICE_SUCCESS'
export const DETAIL_SERVICE_DOMAIN_SERVICE_FAIL = 'DETAIL_SERVICE_DOMAIN_SERVICE_FAIL'

export const DETAIL_SERVICE_DOMAIN_REQUEST = 'DETAIL_SERVICE_DOMAIN_REQUEST'
export const DETAIL_SERVICE_DOMAIN_SUCCESS = 'DETAIL_SERVICE_DOMAIN_SUCCESS'
export const DETAIL_SERVICE_DOMAIN_FAIL = 'DETAIL_SERVICE_DOMAIN_FAIL'

export const UPDATE_SERVICE_DOMAIN_REQUEST = 'UPDATE_SERVICE_DOMAIN_REQUEST'
export const UPDATE_SERVICE_DOMAIN_SUCCESS = 'UPDATE_SERVICE_DOMAIN_SUCCESS'
export const UPDATE_SERVICE_DOMAIN_FAIL = 'UPDATE_SERVICE_DOMAIN_FAIL'

export const UPDATE_SERVICE_DOMAIN_SERVICE_REQUEST = 'UPDATE_SERVICE_DOMAIN_SERVICE_REQUEST'
export const UPDATE_SERVICE_DOMAIN_SERVICE_SUCCESS = 'UPDATE_SERVICE_DOMAIN_SERVICE_SUCCESS'
export const UPDATE_SERVICE_DOMAIN_SERVICE_FAIL = 'UPDATE_SERVICE_DOMAIN_SERVICE_FAIL'

export const DELETE_SERVICE_DOMAIN_REQUEST = 'DELETE_SERVICE_DOMAIN_REQUEST'
export const DELETE_SERVICE_DOMAIN_SUCCESS = 'DELETE_SERVICE_DOMAIN_SUCCESS'
export const DELETE_SERVICE_DOMAIN_FAIL = 'DELETE_SERVICE_DOMAIN_FAIL'

export const DELETE_SERVICE_DOMAIN_SERVICE_REQUEST = 'DELETE_SERVICE_DOMAIN_SERVICE_REQUEST'
export const DELETE_SERVICE_DOMAIN_SERVICE_SUCCESS = 'DELETE_SERVICE_DOMAIN_SERVICE_SUCCESS'
export const DELETE_SERVICE_DOMAIN_SERVICE_FAIL = 'DELETE_SERVICE_DOMAIN_SERVICE_FAIL'

export const RESET_SERVICE_DOMAIN = 'RESET_SERVICE_DOMAIN'
